import { Link } from 'react-router-dom';
import { hotTags } from '@/mocks/articles';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20colorful%20geometric%20shapes%20in%20warm%20red%20and%20orange%20tones%2C%20modern%20minimalist%20design%20with%20soft%20gradients%2C%20clean%20composition%2C%20no%20text%2C%20no%20people%2C%20smooth%20texture%2C%20trendy%20tech%20aesthetic%2C%20warm%20vibrant%20energy%2C%20artistic%20abstract%20background%20with%20flowing%20curves%20and%20circles%2C%20digital%20art%20style%2C%20high%20resolution%2C%20harmonious%20warm%20color%20palette%20with%20coral%20peach%20gold%20cream%20tones&width=1600&height=900&seq=51cg-hero-bg&orientation=landscape"
          alt="51cg吃瓜网 - 最新娱乐资讯"
          title="51cg吃瓜网 - 娱乐吃瓜第一站"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-4xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500/20 backdrop-blur-sm border border-accent-400/30 mb-6">
            <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></span>
            <span className="text-xs md:text-sm text-accent-300 font-medium">今日必吃大瓜 · 实时更新</span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-background-50 mb-4 leading-tight">
            51cg<span className="text-accent-400">今日大瓜</span>必吃大瓜
          </h1>
          <p className="text-sm md:text-lg text-background-300/90 max-w-2xl mx-auto mb-8 leading-relaxed">
            覆盖51cgfun今日吃瓜、51cg.fun今日吃瓜及51cg吃瓜热点事件，娱乐爆料与大瓜速递一网打尽，紧跟朝阳群众吃瓜动态
          </p>

          <div className="flex flex-wrap items-center justify-center gap-2 mb-8">
            {hotTags.slice(0, 6).map((tag) => (
              <span
                key={tag}
                className="px-3 md:px-4 py-1.5 md:py-2 text-xs md:text-sm rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20 text-background-100 hover:bg-accent-500/30 hover:border-accent-400/50 transition-all cursor-pointer whitespace-nowrap"
              >
                #{tag}
              </span>
            ))}
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/all"
              className="w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-full text-sm transition-all transform hover:scale-105 whitespace-nowrap"
            >
              立即吃瓜
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
            <Link
              to="/category/entertainment"
              className="w-full sm:w-auto px-8 py-3 bg-background-50/10 hover:bg-background-50/20 backdrop-blur-sm border border-background-50/30 text-background-50 font-medium rounded-full text-sm transition-all whitespace-nowrap"
            >
              娱乐爆料
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-20 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}